import NiceModal, { useModal } from '@ebay/nice-modal-react'
import React from 'react'
import { createMVPModal } from '../Modal'
import { WalletAddFundsModalView } from './WalletAddFundsModalView'
import WalletAddressModal from '../WalletAddressModal/WalletAddressModal'
import { useActiveUser } from '../../../state/hooks/ActiveUserHooks'
import { useDepositBonus } from '../../../state/hooks/ProfileDataHooks'
import WalletDepositBonusInfoModal from '../WalletDepositBonusInfoModal/WalletDepositBonusInfoModal'
import WalletAddFundsWithProviderModal from '../WalletAddFundsWithProviderModal/WalletAddFundsWithProviderModal'

class WalletAddFundsModal
{
	Show() 
	{
		NiceModal.show(createMVPModal('wallet-add-funds-modal', () =>
		{
			const modal = useModal()
			const activeUser = useActiveUser()!
			const depositBonus = useDepositBonus()
			const gameConfig = activeUser.config
		
			const handleClick = (onClick: () => void) => {
				modal.hide()
				onClick()
			}

			const clickCryptoSevice = () => {
				WalletAddFundsWithProviderModal.Show(gameConfig.availablePaymentProviders?.cryptoPaymentType)
			}
			const clickCreditService = () => {
				WalletAddFundsWithProviderModal.Show(gameConfig.availablePaymentProviders?.creditCardPaymentType)
			}
		
			const clickAddWallet = () => {
				WalletAddressModal.Show()
			}
		
			const clickDepositBonus = () => {
				WalletDepositBonusInfoModal.Show()
			}

			// return <div> </div>
			return <WalletAddFundsModalView 
				activeUser={activeUser}
				depositBonus={depositBonus}

				clickCryptoSevice={() => handleClick(clickCryptoSevice)}
				clickCreditService={() => handleClick(clickCreditService)}
				clickAddWallet={() => handleClick(clickAddWallet)}
				clickDepositBonus={() => handleClick(clickDepositBonus)}
			/>
		}))
	}
}

const modal = new WalletAddFundsModal()
export default modal